module.exports = __webpack_public_path__ + "static/media/4_FC.fb3d36e5.jpg";